// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__P5H1w","wave":"Skeleton_wave__MZgZK"};